import { PlayInsertionType } from "@prestosports/prestostats-core/Football";
import { AppRoutes } from "../../routes/app-routes";
import {
	GET_APP_DATA,
	GET_APP_DATA_COMPLETE,
	GET_CURRENT_EVENT_SYNC_COMPLETE,
	GET_GAME_ACCESS_COMPLETE,
	GET_GAME_MENU_ITEMS_COMPLETE,
	RESET_GAME_ACCESS,
	SET_ALLOW_EVENT_SETTINGS_EDITING,
	SET_CONFIRM_SAVE,
	SET_EDIT_PLAY,
	SET_SELECTED_DATE,
	SET_SELECTED_SPORT,
	SUBMITTING,
	SUBMITTING_COMPLETE,
	GET_TEAM_API_ACCESS_COMPLETE,
	SET_CONFIRM_SETTING_SAVE,
	RESET_CONFIRM_SETTING_SAVE,
	SYNCING_COMPLETE,
	SYNCING,
	ON_ERROR,
	SET_DEBUG_DATA,
	SET_INSERT_PLAY,
	SET_INSERT_TYPE
} from "./constants";

const initialState = {
	AppRoutes,
	menuItems: Object.values(AppRoutes).filter((r) => r.isNavItem),
	gameMenuItems: [],
	isLoading: false,
	timeZones: [],
	gameAccess: [],
	playerManagement: true,
	selectedSport: null,
	sportAccess: null,
	selectedDate: new Date(),
	editPlay: null,
	insertPlay: null,
	insertType: PlayInsertionType.Before,
	confirmSave: false,
	currentEventSync: null,
	isSubmitting: false,
	isSyncing: false,
	allowEventSettingsEditing: false,
	apiAccess: { teams: [] },
	confirmSettingSave: false,
	settingChangeSummary: {},
	debugData: null
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_APP_DATA:
			return {
				...state,
				isLoading: true
			};
		case GET_TEAM_API_ACCESS_COMPLETE:
		case GET_CURRENT_EVENT_SYNC_COMPLETE:
		case GET_GAME_MENU_ITEMS_COMPLETE:
		case GET_APP_DATA_COMPLETE:
		case GET_GAME_ACCESS_COMPLETE:
		case SET_SELECTED_SPORT:
		case SET_SELECTED_DATE:
		case SET_EDIT_PLAY:
		case SET_INSERT_PLAY:
		case SET_INSERT_TYPE:
		case SET_CONFIRM_SAVE:
		case RESET_GAME_ACCESS:
		case SET_ALLOW_EVENT_SETTINGS_EDITING:
		case SET_CONFIRM_SETTING_SAVE:
		case RESET_CONFIRM_SETTING_SAVE:
		case SYNCING:
		case SYNCING_COMPLETE:
		case SET_DEBUG_DATA:
		case ON_ERROR:
			return {
				...state,
				...payload,
				isLoading: false
			};
		case SUBMITTING:
			return { ...state, isSubmitting: true };
		case SUBMITTING_COMPLETE:
			return { ...state, isSubmitting: false };
		default:
			return state;
	}
};

export default reducer;
